var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"btn btn-info btn-file",on:{"change":_vm.changeHandler}},[_c('i',{staticClass:"fa fa-upload"}),_c('input',{attrs:{"type":"file","multiple":""}}),_vm._v("\nUpload")])}
var staticRenderFns = []

export { render, staticRenderFns }